import initialState from './initialState';
import {
} from '../../actions/home/types';
import ReducersTooling from '../../../tooling/reducersTooling';

export default function home(state = initialState, action) {
  switch (action.type) {      
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./source/client/reducers/home/index.js